export default [
	{	
		"_id":"1",
		"color":"#f55b2a",
		"card": "card", 
		"href": "#", 
		"title": "De-La-Chef in the community",
		"circle": "box-shadow bg-white rounded-circle mx-auto text-center card-sizes", 
		"imClass": "fa fa-users",
		"cardBody": "card-body text-center", 
		"cardTitle": "card-title pt-1", 
		"cardDescription": "card-text text-sm",
		"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.",  
		"learnMore": "Learn More&nbsp;", 
		"icon":"fe-icon-arrow-right", 
		"bgHover": "our-services bgHover_2"
	},
	{	
		"_id":"2",
		"color":"#9d8277",
		"card": "card", 
		"href": "#", 
		"title": "Culinary and pastry arts school",
		"circle": "box-shadow bg-white rounded-circle mx-auto text-center card-sizes", 
		"imClass": "fa fa-briefcase",
		"cardBody": "card-body text-center", 
		"cardTitle": "card-title pt-1", 
		"cardDescription": "card-text text-sm",
		"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.",  
		"learnMore": "Learn More&nbsp;", 
		"icon":"fe-icon-arrow-right", 
		"bgHover": "our-services bgHover_1"
	},
	{	
		"_id":"3",
		"color":"#5d6c59",
		"card": "card", 
		"href": "#", 
		"title": "Culinary museum",
		"circle": "box-shadow bg-white rounded-circle mx-auto text-center card-sizes", 
		"imClass": "fa fa-fort-awesome",
		"cardBody": "card-body text-center", 
		"cardTitle": "card-title pt-1", 
		"cardDescription": "card-text text-sm",
		"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.",  
		"learnMore": "Learn More&nbsp;", 
		"icon":"fe-icon-arrow-right", 
		"bgHover": "our-services bgHover_3"
	},
	{	
		"_id":"4",
		"color":"#207a85",
		"card": "card", 
		"href": "#", 
		"title": "Cooking and Serving at home",
		"circle": "box-shadow bg-white rounded-circle mx-auto text-center card-sizes", 
		"imClass": "fa fa-cutlery",
		"cardBody": "card-body text-center", 
		"cardTitle": "card-title pt-1", 
		"cardDescription": "card-text text-sm",
		"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.",  
		"learnMore": "Learn More&nbsp;", 
		"icon":"fe-icon-arrow-right", 
		"bgHover": "our-services bgHover_4"
	},
	{	
		"_id":"5",
		"color":"#7e5670",
		"card": "card", 
		"href": "#", 
		"title": "Romantic meals outdoors",
		"circle": "box-shadow bg-white rounded-circle mx-auto text-center card-sizes", 
		"imClass": "fa fa-envira",
		"cardBody": "card-body text-center", 
		"cardTitle": "card-title pt-1", 
		"cardDescription": "card-text text-sm",
		"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.",  
		"learnMore": "Learn More&nbsp;", 
		"icon":"fe-icon-arrow-right", 
		"bgHover": "our-services bgHover_5"
	},
	{	
		"_id":"6",
		"color":"#b9ccd2",
		"card": "card", 
		"href": "#", 
		"title": "Food delivery to your place",
		"circle": "box-shadow bg-white rounded-circle mx-auto text-center card-sizes", 
		"imClass": "fa fa-car",
		"cardBody": "card-body text-center", 
		"cardTitle": "card-title pt-1", 
		"cardDescription": "card-text text-sm",
		"description": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip.",  
		"learnMore": "Learn More&nbsp;", 
		"icon":"fe-icon-arrow-right", 
		"bgHover": "our-services bgHover_6"
	},
	]

